module.exports = __webpack_public_path__ + "static/media/map-icon-active.96d03283.svg";